import React from 'react';

import * as S from './style';

interface IProps {
  className?: string;
  children?: React.ReactNode;
}

const BrandNewTemplate = ({ children, className }: IProps) => (
  <S.BrandNewTemplate className={className}>{children}</S.BrandNewTemplate>
);

export default BrandNewTemplate;
